import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { growVertical } from 'src/app/animations';
import { FormChecks } from 'src/app/pwa/auth/form-checks';
import { DialogService } from 'src/app/services/dialog.service';
import { RcActualizaPassService } from 'src/app/services/recuperacion/rc-actualiza-pass.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css'],
  animations: [growVertical]
})
export class PasswordChangeComponent implements OnInit {

  @Input() caducada: boolean;

  hideActual: boolean = true;
  hideNueva: boolean = true;
  hideConfirma: boolean = true;
  validPassword: boolean = false;

  public passwordForm: FormGroup;
  private user;

  constructor(
    private fb: FormBuilder,
    private api: RcActualizaPassService,
    public activatedRoute: ActivatedRoute,
    public dialogService: DialogService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.user = localStorage.getItem('user')

    this.passwordForm = this.fb.group({
      'oldPassword': [null, [
        Validators.required
      ]],
      'newPassword': [{
        value: null,
        disabled: true
      }, [
        Validators.required,
        Validators.minLength(8),
        FormChecks.checkNumber,
        FormChecks.checkSpecialCharacter,
        FormChecks.checkMayus,
        FormChecks.checkMinus
      ]],
      'confirmPassword': [{
        value: null,
        disabled: true
      }, [
        Validators.required,
        Validators.minLength(8),
        FormChecks.checkNumber,
        FormChecks.checkSpecialCharacter,
        FormChecks.checkMayus,
        FormChecks.checkMinus
      ]]
    }, {
      validators: FormChecks.checkIfEqual
    });

    if (this.caducada) {
      this.passwordForm.get('newPassword')?.enable();
      this.passwordForm.get('confirmPassword')?.enable();
    } else {
      this.passwordForm.get('oldPassword')?.valueChanges
        .pipe(
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe(value => {
          this.validationPassword();
        });
    }
  }

  // validacion de clave actual
  validationPassword() {
    this.api.validationPassword(
      this.user,
      this.passwordForm.get('oldPassword').value,
      "1",
      1
    )
      .subscribe(
        (data: any) => {
          if (data.faError == -12) {
            this.validPassword = false
            this.passwordForm.get('oldPassword')?.setErrors({ incorrect: true });
            this.passwordForm.get('newPassword').disable();
            this.passwordForm.get('confirmPassword').disable();
          } else {
            this.validPassword = true
            this.passwordForm.get('oldPassword').disable()
            this.passwordForm.get('newPassword').enable();
            this.passwordForm.get('confirmPassword').enable();
          }
        }
      );
  }

  protected actRc() {
    if (this.passwordForm.valid) {
      this.api.validationPassword(
        this.user,
        this.passwordForm.get('oldPassword')?.value,
        this.passwordForm.get('newPassword')?.value,
        2
      ).subscribe({
        next: (data: any) => {
          if (data.faError === 0) {
            if (this.caducada) {
              this.dialogService.openDialog("¡Contraseña actualizada!","Ya puedes iniciar sesión con tu nueva contraseña",true,"Iniciar sesión",()=>{
                this.router.navigate(['/iniciar-sesion']);
              })
            } else {
              this.dialogService.openDialog("¡Creaste una nueva contraseña!", "", true, "Ir al inicio", () => {
                this.router.navigate(['/home']);
              }, true, "Volver a mi perfil", () => {
                this.router.navigate(['/mi-perfil']);
              }
              )
            }
          } else {
            this.dialogService.openDialog("Error!", data.faDescripcion, false);
          }
        },
        error: () => {
          this.dialogService.openDialog("!", "Error actualizando contraseña", false);
        }
      });
    }


  }

  goToProfile() {
    this.router.navigate(['/mi-perfil']);
  }
}
